"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var measureTextWidth = function measureTextWidth(text) {
  var fontStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "normal";
  var fontWeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "14px";
  var fontFamily = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '"Open Sans", Arial, "Helvetica Neue", Helvetica, sans-serif';
  var canvas = document.createElement("canvas");
  var ctx = canvas.getContext("2d");
  ctx.font = "".concat(fontStyle, " ").concat(fontWeight, " ").concat(fontFamily);
  var mt = ctx.measureText(text);
  return mt.width;
};

var _default = measureTextWidth;
exports["default"] = _default;